module.exports = __webpack_public_path__ + "img/Dantam Bridal 18.32bc6ff9.jpg";